import {getHashFromLink} from 'app/utils/initialize/getHashFromLink';

export const NON_SECTION_LINK_WITH_HASH_SELECTOR = 'a[href*="#"]:not([data-scroll-anchor])';
export const LINK_WITH_HASH_SELECTOR = 'a[href*="#"]';

export function pageLinkHashHasId(id: string) {
    return Array.from(document.querySelectorAll<HTMLAnchorElement>(NON_SECTION_LINK_WITH_HASH_SELECTOR)).some((link) => {
        const hash = getHashFromLink(link);
        return hash && hash === id;
    });
}
